/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccountEntity
 */
export interface AccountEntity {
    /**
     * アカウントID
     * @type {string}
     * @memberof AccountEntity
     */
    id: string;
    /**
     * Auth-ID
     * 認証基盤側で採番されるユーザーアカウントを一意に特定するID。
     * @type {string}
     * @memberof AccountEntity
     */
    authId: string;
    /**
     * メールアドレス
     * @type {string}
     * @memberof AccountEntity
     */
    email: string;
}

/**
 * Check if a given object implements the AccountEntity interface.
 */
export function instanceOfAccountEntity(value: object): value is AccountEntity {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('authId' in value) || value['authId'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function AccountEntityFromJSON(json: any): AccountEntity {
    return AccountEntityFromJSONTyped(json, false);
}

export function AccountEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'authId': json['authId'],
        'email': json['email'],
    };
}

export function AccountEntityToJSON(json: any): AccountEntity {
    return AccountEntityToJSONTyped(json, false);
}

export function AccountEntityToJSONTyped(value?: AccountEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'authId': value['authId'],
        'email': value['email'],
    };
}

